module.exports = __webpack_public_path__ + "img/14_julia_h.e166a66d.png";